
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.09 7.328a3.12 3.12 0 002.986 2.213h4.3c1.09 0 1.538 1.399.651 2.033l-3.55 2.537a3.12 3.12 0 00-1.167 3.462l1.47 4.747c.322 1.041-.88 1.883-1.748 1.224l-3.649-2.769a3.12 3.12 0 00-3.775.002L6.98 23.535c-.868.66-2.07-.182-1.749-1.223l1.467-4.738a3.12 3.12 0 00-1.168-3.463l-3.555-2.537c-.888-.633-.44-2.033.65-2.033h4.292A3.12 3.12 0 009.9 7.328l1.522-5.01c.322-1.06 1.823-1.06 2.145 0l1.522 5.01z","stroke":"#56BFC7","stroke-width":"2"}})])
          )
        }
      }
    